import '../../resources/css/site/SiteBlocks.scss';
import React,{ Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { doSelectSite, loadSiteSummary } from '../../actions/site/index';
import { saveModelOrgGroupDetailData, filterOrgAction, getModelOrgDetail, loadGroupList } from '../../actions/model/index';
import ModalSiteDetail from './ModalSiteDetail';
import { popupModalConfirm, openModal, closeModal, openModalAlert } from '../../actions/index';
import { doActivePage } from '../../actions/menu/index';
import { doChangeTimeZoneId } from '../../actions/login';
import { doGetNotify } from '../../actions/account';
// import Loading from '../../components/common/Loading';

let componentProps = null; 

class SiteBlocks extends Component {

  tableId = 'SiteBlocks'
  refFilterSearch = null
  refListCommonFooter = null
  // set this state for re-fresh sub component
  state = {
    refTable: null,
    deviceUsage: null,
    userUsage: null,
    isInitComplete: false,
    status: 'DO_RELOAD',
  }

  dataLoading = (datas) => {
    if (this.ref && !this.state.isInitComplete) {
      if (!componentProps) {
        componentProps = this.props;
      }

      // refTabulatorTable = this.ref.table

      // save into state
      this.setState({
        isInitComplete: true,
        refTable: this.ref.table
      });
    }
  }

  addRow = () => {   
      const { getModelOrgDetail, openModal, authToken } = this.props;
      openModal("modelOrganization", 'add', null, () => getModelOrgDetail(authToken, -1));    
  }

  viewRow = (data) => {
      // let data = props.cell._cell.row.data;
      const { getModelOrgDetail, openModal, doChangeTimeZoneId } = this.props;
      openModal("modelOrganization", 'view', null, () => {doChangeTimeZoneId(data.timezone); getModelOrgDetail(data);});
  }

  selectSiteBlock = (item) => {
    const { doSelectSite, doChangeTimeZoneId, authToken, loadGroupList } = this.props;
    doChangeTimeZoneId(item.timezone);
    doSelectSite(item.id);
    // doGetNotify(item.id, authToken);
    loadGroupList(authToken, item.id ? item.id : -1);
  }

  renderSiteBlocks = () => {
    const { siteSummaryList } = this.props;
    let displaySiteList = [];
    // let i = 0;
    if (siteSummaryList.length === 1) {
      displaySiteList.push(1);
      displaySiteList.push(2);
      displaySiteList.push(2);
      displaySiteList.push(siteSummaryList[0]);
    } 
    else if (siteSummaryList.length <= 3) {
      displaySiteList.push(1);
      displaySiteList.push(2);
      for (let i = 0; i < 3; i++) {
        if (i < siteSummaryList.length) {
          displaySiteList.push(siteSummaryList[i]);
        } else {
          displaySiteList.push(2);
        }
      }
      // displaySiteList.push(2);
      // displaySiteList.push(1);
    } 
    else if (siteSummaryList.length <= 5) {
      // displaySiteList.push(1);
      for (let i = 0; i < 5; i++) {
        if (i < siteSummaryList.length) {
          displaySiteList.push(siteSummaryList[i]);
        } else {
          displaySiteList.push(2);
        }
      }
      // displaySiteList.push(1);
    } 
    else {
      for (let i = 0; i < siteSummaryList.length; i++) {
        displaySiteList.push(siteSummaryList[i]);
      }     
    }


    return displaySiteList.map((item, index) => {
      return this.renderSiteBlock(item, index);
    });
  }

//   onClick(e) {
//     e.stopPropagation();
//     this.viewRow();
//  }

  renderSiteBlock = (item, index) => {
    if (typeof item === 'number') {
      return (
      <Col sm={item} key={index}></Col>
      );
    } else {
      return (
        <Col sm={2} key={index}>
          <div className='area-site-block' onClick={() => this.selectSiteBlock(item)}>
            <div className='btn-areas'><span className='icon-btn-info-n' onClick={(event) => { event.stopPropagation(event); this.viewRow(item);}} /></div>
            <div className='area-device-icon-custom'><span className='icon-product-m-10'></span></div>          
            <div className='area-site-name'>{item.name}</div>
            <div className='area-site-desc'>{item.description}</div>
            {/* <div className='area-site-block-botton'>
              <Row>
                <Col sm={6}>
                  <div className='area-device'>
                    <span className='icon-item btn-devices-n'></span>
                    <span className='info-number'>{item.devices}</span>
                  </div>
                </Col>
                <Col sm={6}>
                <div className='area-users'>
                  <span className='icon-item btn-users-n'></span>
                  <span className='info-number'>{item.clients}</span>
                </div>
                </Col>
              </Row>
            </div> */}
          </div>
        </Col>
      );
    }
  }
  
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { menuMode } = this.props;
    const { refTable } = this.state;

    if (refTable) {
      if (prevProps.menuMode !== menuMode) {
        // if menu chagne size(mode), need redraw table     
        refTable.redraw(true);
      }
    }
  }

  render() {
    return (
      <div className='area-site-blocks'>
        <Row>
          { this.renderSiteBlocks() }
          <div className='area-site-block-add' onClick={() => this.addRow()}>
            <div className='area-device-icon'><span className='icon-add-new-site'></span></div>
            <div className='area-site-add'>Add new site</div>
          </div>
          <ModalSiteDetail></ModalSiteDetail>
        </Row>   
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    authToken: state.loginReducers.authToken,
    siteSummaryList: state.siteReducers.siteSummaryList,
    accountInfo: state.loginReducers.accountInfo,
    menuMode: state.menuReducers.displayMode,
    accountRole: state.loginReducers.accountRole,
    status: state.siteReducers.status,
    selectSite: state.siteReducers.selectSite,
    timeZoneID: state.loginReducers.timeZoneID
  }
}

const mapDispatchToProps = {
  doActivePage,
  openModal,
  closeModal,
  getModelOrgDetail,
  popupModalConfirm,
  saveModelOrgGroupDetailData,
  openModalAlert,
  doSelectSite,
  filterOrgAction,
  doChangeTimeZoneId,
  doGetNotify,
  loadSiteSummary,
  loadGroupList
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(SiteBlocks))
